// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { DemoRoutesAreaId } from './DemoRoutesAreaId'
import { DemoRoutesAreaNavigation } from './DemoRoutesAreaNavigation'
import { DemoRoutesAreaRoutes } from './DemoRoutesAreaRoutes'

const LazyDemoRoutesComponent = lazy(() => import('./DemoRoutesArea'))

const DemoRoutesComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyDemoRoutesComponent />
  </SuspenseLoadingWrapper>
)

export const DemoRoutesArea = {
  id: DemoRoutesAreaId,
  requiredRight: BoumRight.AREA_DEMO_ROUTE_MANAGEMENT,
  NavigationComponent: DemoRoutesAreaNavigation,
  route: {
    path: DemoRoutesAreaRoutes.route,
    component: DemoRoutesComponent,
  },
}
